module.exports = __webpack_public_path__ + "static/media/acl-logo.1d668848.svg";